import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "27px",
    color: "#465869",
  },
  image: {
    width: "100%",
    height: "114px",
    borderRadius: "8px",
    cursor: "pointer",
  },
  inputFile: {
    display: "none",
  },
  skeleton: {
    height: "220px !important",
    width: "100% !important",
    borderRadius: "8px",
  },
  imageList: {
    marginTop: "12px",
  },
  subTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#9CA6AF",
  },
}));

export const ImageContainer = styled("div")(() => ({
  width: "100%",
  height: "480px",
}));

export const EmptyPhotoContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const NoPhotosAddedYetSpan = styled("span")(() => ({
  color: "#98A2B3",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
}));

export default styles;
